export default __webpack_public_path__ + "static/media/Grossmutter-beim-Kiosk.3ed13b29.png";